import { getCookie } from '@utiljs/cookie';

import utils from './utils';

const urlParams: any = utils.urlParse();
const wmPoiId = urlParams.wmPoiId || getCookie('wmPoiId');
const acctId = urlParams.acctId || getCookie('acctId');

// global env
const globalEnv = {};

const getValLab = (val?: any | null) => ({
    // eslint-disable-next-line
    poi_id: wmPoiId,
    custom: {
        // eslint-disable-next-line
        user_id: acctId,
        ...val,
    },
});

export default {
    // pv事件
    pv(cid: string, val: any | null, env: any | null) {
        if (!cid) {
            console.error('pv未填写cid');
            return;
        }
        const valLab = getValLab(val);
        const environment = {
            ...globalEnv,
            ...env,
        };
        try {
            window.LXAnalytics('pageView', valLab, environment, cid);
        } catch (e) {
            //
        }
    },
    // 曝光事件
    mv(bid: string, val?: any, cid?: string) {
        if (!bid) {
            console.error('mv未填写bid');
            return;
        }
        const valLab = getValLab(val);
        try {
            window.LXAnalytics('moduleView', bid, valLab, { cid });
        } catch (e) {
            //
        }
    },
    // 点击事件
    click(bid: string, val?: any, cid?: string) {
        if (!bid) {
            console.error('click未填写bid');
            return;
        }
        const valLab = getValLab(val);
        try {
            window.LXAnalytics('moduleClick', bid, valLab, { cid });
        } catch (e) {
            //
        }
    },
    // get事件，获取相应信息
    lxGet(key: string) {
        return new Promise(resolve => {
            const cb = (value: string) => {
                if (value !== null && value !== undefined) {
                    resolve(value);
                } else {
                    resolve('000000');
                }
            };
            window.LXAnalytics('get', key, cb);
        });
    },
};
